import{f as a}from"./chunk-G2JJCVCL.js";import*as o from"react";var f=o[" useId ".trim().toString()]||(()=>{}),s=0;function n(t){let[r,e]=o.useState(f());return a(()=>{t||e(u=>u??String(s++))},[t]),t||(r?`radix-${r}`:"")}export{n as a};
